import { Button } from "@controls";
import { useLimitModal } from "@src/modules/member/context/limit-modal-context/hook";
import { useSubscription } from "@src/modules/member/hooks/subscription";
import { useMemberPath } from "@src/modules/member/hooks/use-member-path";
import Modal from "@src/raya-lucaria/components/modal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { BILLING_PATH, BILLING_PLANS_PATH } from "../../router/paths";

export default function LimitReachedModal() {
  const { payload, hide } = useLimitModal();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { settingsPath } = useMemberPath();
  const subscription = useSubscription().data?.data ?? null;

  if (!payload) return null;

  const featureLabel = t(
    `member.settings.billing.usageDashboard.features.${payload.feature}`,
    { defaultValue: payload.feature },
  ).toLowerCase();

  const planType = subscription?.plan?.type;
  const isPro = planType === "pro";
  const bodyKey = payload.spending_cap_reached
    ? "member.settings.billing.limitReached.bodyProSpendingCap"
    : isPro && !payload.overage_enabled
      ? "member.settings.billing.limitReached.bodyProNoOverage"
      : "member.settings.billing.limitReached.bodyFree";

  const ctaLabel = payload.spending_cap_reached
    ? t("member.settings.billing.limitReached.manageCapCta")
    : isPro
      ? t("member.settings.billing.limitReached.enableOverageCta")
      : t("member.settings.billing.limitReached.upgradeCta");

  const ctaTarget =
    payload.spending_cap_reached || isPro
      ? BILLING_PATH()
      : BILLING_PLANS_PATH();

  return (
    <Modal
      open
      onOpenChange={(next: boolean) => !next && hide()}
      title={t("member.settings.billing.limitReached.title", {
        feature: featureLabel,
      })}
      description={t(bodyKey, {
        feature: featureLabel,
        current: payload.current,
        limit: payload.limit ?? "",
      })}
      size="md"
    >
      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={hide}>
          {t("member.settings.billing.limitReached.close")}
        </Button>
        <Button
          type="button"
          onClick={() => {
            hide();
            navigate(settingsPath(ctaTarget));
          }}
        >
          {ctaLabel}
        </Button>
      </div>
    </Modal>
  );
}
